import { render, staticRenderFns } from "./BadgeStatusInvoice.vue?vue&type=template&id=4cb228ab&scoped=true&"
import script from "./BadgeStatusInvoice.vue?vue&type=script&lang=js&"
export * from "./BadgeStatusInvoice.vue?vue&type=script&lang=js&"
import style0 from "./BadgeStatusInvoice.vue?vue&type=style&index=0&id=4cb228ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb228ab",
  null
  
)

export default component.exports